import React from 'react';

/* Инлайн, а не файл: виджет встраивается на чужих хостах, где
   /widget/telegram-icon.svg не существует — img молча пропадал.
   Вектор из Figma (Telegram — Iconly Pro). */
export const TelegramIcon: React.FC<{ size?: number; fill: string }> = ({ size = 17, fill }) => (
  <svg
    width={size}
    height={Math.round(size * (15 / 17))}
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.96578 11.1114L7.04578 12.8956C6.81075 13.1148 6.42825 12.9348 6.44992 12.6139C6.50992 11.7073 6.60325 10.3298 6.66575 9.56392C6.67575 9.44309 6.77742 9.30809 6.87411 9.22059C9.11661 7.18726 11.3641 5.15892 13.6108 3.12893C13.6941 3.05393 13.7924 2.86893 13.7408 2.77143C13.6824 2.66143 13.4133 2.69476 13.3016 2.76476C10.4483 4.56143 7.59495 6.35726 4.74575 8.15976C4.57075 8.26976 4.35659 8.29642 4.15992 8.23309C2.98492 7.85559 1.80325 7.49809 0.625754 7.12642C0.35492 7.04059 0.0332537 6.95559 0.00242033 6.61976C-0.0300797 6.26892 0.270754 6.10226 0.54242 5.99309C1.63742 5.55142 2.73992 5.12892 3.84075 4.70393C7.80078 3.1781 11.7608 1.6531 15.7208 0.128097C15.8533 0.0772641 16.0299 0.0455975 16.1683 0.0180975C16.5833 -0.0652358 16.9566 0.143098 16.9974 0.563098C17.0283 0.870598 16.9741 1.2131 16.9099 1.51726C16.0849 5.44142 15.2491 9.36392 14.4141 13.2873C14.1891 14.3473 13.6441 14.5481 12.7666 13.9006C11.6358 13.0656 8.96578 11.1114 8.96578 11.1114Z"
      fill={fill}
    />
  </svg>
);
